import React, { useState, useEffect } from "react";
import teamimage from "../assets/RapidCarLogo.png";
import delicon from "../assets/delete.svg";
import update from "../assets/editBlack.svg";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Modal, Button } from "react-bootstrap";
import Loader from "./Loader.js";
import DropDwn from "../assets/drop-dwn.png";
import {
  handleError,
  check_vaild_save,
  combiled_form_data,
  empty_form,
  empty_form_new,
  handleIaphabetnumberChange,
  inputdateformateChangeyear,
  mondayDayYearFormat,
  handleAphabetsChange,
  handleSuccess,
  handleURLChange,
  handleNumbersChange,
  goBack,
} from "../CommonJquery/CommonJquery";
import {
  APL_LINK,
  server_post_data,
  save_update_blog,
  delete_website_master_data,
  get_all_blogs,
} from "../ServiceConnection/serviceconnection.js";
import { BlogWebsite_text } from "../CommonJquery/WebsiteText";
import Multiselect from "multiselect-react-dropdown";
import { ArrowLeft, Delete, Trash, Trash2, X } from "lucide-react";
const BlogWebsite = () => {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editStaffData, seteditStaffData] = useState([]);
  const [editStaffDataDetails, seteditStaffDataDetails] = useState([]);
  const [editorDataMainID, setEditorDatMainID] = useState("0");
  const [SelectedData, setSelectedData] = useState([]);
  const [blogDataKeyWord, setBlogDataKeyWord] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [editorData, setEditorData] = useState("");
  const [editorData2, setEditorData2] = useState("");
  const [editorData3, setEditorData3] = useState("");
  const [uploadedImages, setUploadedImages] = useState([]);
  const [BlogImage, setBlogImage] = useState("");
  const [BlogImage1, setBlogImage1] = useState("");
  const [BlogImage2, setBlogImage2] = useState("");
  const [BlogImage3, setBlogImage3] = useState("");
  const [error_show, seterror_show] = useState("");
  const [selectedKeyword, setSelectedKeyword] = useState("");
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  const [otherKeyword, setOtherKeyword] = useState("");
  const [ALLblogFaq, setALLblogFaq] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [filteredData, setFilteredData] = useState([]);

  const handleToggleForm = () => {
    setFormVisible(!formVisible);
  };

  const onSelect = (selectedList, selectedItem) => {
    setSelectedValues(selectedList);
  };

  const onRemove = (selectedList, removedItem) => {
    setSelectedValues(selectedList);
  };

  useEffect(() => {
    const flag = "1";
    let call_id = "0";
    master_data_get("", "", flag, call_id);
  }, []);

  useEffect(() => {
    setFilteredData(editStaffData);
  }, [editStaffData]);

  const handleDeactivate = () => {
    master_data_action_update(SelectedData.primary_id, "d");
  };

  const handleClose = () => {
    setModalShow(false);
  };

  const handleShow = (data_call) => {
    setSelectedData(data_call);
    setModalShow(true);
  };

  const handleEdit = (data_call) => {
    master_data_get("", "", "3", data_call.primary_id);
  };

  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setEditorData(data);
    //console.log("Editor Content:", data);
  };

  const handleEditorChange2 = (event, editor) => {
    const data = editor.getData();
    setEditorData2(data);
    //console.log("Editor Content:", data);
  };

  const handleEditorChange3 = (event, editor) => {
    const data = editor.getData();
    setEditorData3(data);
    //console.log("Editor Content:", data);
  };

  function base64UploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          loader.file.then((file) => {
            const reader = new FileReader();
            reader.onload = () => {
              const base64Image = reader.result;
              const imageInfo = {
                id: Date.now(),
                name: file.name,
                size: file.size,
                type: file.type,
                base64: base64Image,
                uploadTime: new Date().toLocaleString(),
              };
              setUploadedImages((prev) => [...prev, imageInfo]);
              //console.log("New Image Uploaded:", imageInfo);
              //console.log("All Images:", [...uploadedImages, imageInfo]);

              resolve({
                default: base64Image,
              });
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
          });
        });
      },
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return base64UploadAdapter(loader);
    };
  }

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("start_date", start_date);
    fd.append("end_date", end_date);
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    await server_post_data(get_all_blogs, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          if (Response.data.message.data_blog.length > 0) {
            seteditStaffData(Response.data.message.data_blog);
            setFilteredData(Response.data.message.data_blog);
            setBlogDataKeyWord(Response.data.message.data_blog_keyword);
            setALLblogFaq(Response.data.message.data_blog_faq);
            if (flag === "3") {
              seteditStaffDataDetails(Response.data.message.data_blog[0]);
              console.log(Response.data.message.data_blog[0]);
              const selectedFaqObjects = Response.data.message.data_blog_faq_id;

              // Extract only the IDs from selected objects
              const selectedIds = selectedFaqObjects.map((faq) => faq.faq_id);

              const preselected = Response.data.message.data_blog_faq.filter(
                (faq) => selectedIds.includes(faq.primary_id)
              );
              setSelectedValues(preselected);
              setEditorDatMainID(Response.data.message.data_blog[0].primary_id);
              setEditorData(Response.data.message.data_blog[0].description);
              setEditorData2(Response.data.message.data_blog[0].description2);
              setEditorData3(Response.data.message.data_blog[0].description3);
              setBlogImage(Response.data.message.data_blog[0].image_url);
              setBlogImage1(Response.data.message.data_blog[0].image_url1);
              setBlogImage2(Response.data.message.data_blog[0].image_url2);
              setBlogImage3(Response.data.message.data_blog[0].image_url3);
              setSelectedKeyword(Response.data.message.blog_image[0].keyword);
              setFormVisible(true);
            } else {
              seteditStaffDataDetails([]);
            }
          }
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const master_data_action_update = async (call_id, for_status_final) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();

    fd.append("id_for_delete", call_id);
    fd.append("flag_for", "1");
    fd.append("for_status_final", for_status_final);
    await server_post_data(delete_website_master_data, fd)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          handleClose();
          master_data_get("", "", "1", "0");
        }
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const resetForm = () => {
    setEditorDatMainID("0");
    setEditorData("");
    setEditorData2("");
    setEditorData3("");
    setBlogImage("");
    setBlogImage1("");
    setBlogImage2("");
    setBlogImage3("");
    seterror_show("");
    setOtherKeyword("");
    setSelectedValues([]);
    setSelectedFileBlog(null);
    setSelectedFileBlog2(null);
    setSelectedFileBlog4(null);
    setSelectedFileBlog5(null);
    seteditStaffDataDetails([]);
  };

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);

    if (vaild_data) {
      if (editorData.length > 0) {
        setshowLoaderAdmin(true);
        let fd_from = combiled_form_data(form_data, null);
        fd_from.append("main_id", editorDataMainID);
        fd_from.append("description_data", editorData);
        fd_from.append("description_data2", editorData2);
        fd_from.append("description_data3", editorData3);
        fd_from.append("old_image_blog", BlogImage);
        fd_from.append("old_image_blog1", BlogImage1);
        fd_from.append("old_image_blog2", BlogImage2);
        fd_from.append("old_image_blog3", BlogImage3);
        fd_from.append("otherKeyword", otherKeyword);
        fd_from.append("selectfaqdata", JSON.stringify(selectedValues));
        await server_post_data(url_for_save, fd_from)
          .then((Response) => {
            setshowLoaderAdmin(false);
            if (Response.data.error) {
              handleError(Response.data.message);
            } else {
              master_data_get("", "", "1", "0");
              handleSuccess(Response.data.message);

              setFormVisible(false);
              empty_form(form_data);
              resetForm();
            }
          })
          .catch((error) => {
            console.log(error);
            setshowLoaderAdmin(false);
          });
      } else {
        seterror_show("Please Fill The Mandatory Information");
      }
    }
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileBlog, setSelectedFileBlog] = useState(null);
  const [selectedFileBlog2, setSelectedFileBlog2] = useState(null);
  const [selectedFileBlog4, setSelectedFileBlog4] = useState(null);
  const [selectedFileBlog5, setSelectedFileBlog5] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    } else {
      setSelectedFile(null);
    }
  };

  const handleFileChange2 = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFileBlog(file);
    } else {
      setSelectedFileBlog(null);
    }
  };

  const handleFileChange3 = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFileBlog2(file);
    } else {
      setSelectedFileBlog2(null);
    }
  };

  const handleFileChange4 = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFileBlog4(file);
    } else {
      setSelectedFileBlog4(null);
    }
  };

  const handleFileChange5 = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFileBlog5(file);
    } else {
      setSelectedFileBlog5(null);
    }
  };

  const handleKeywordChange = (e) => {
    const value = e.target.value;

    if (value === "other") {
      setSelectedKeyword("other");
      setIsOtherSelected(true);
    } else {
      setSelectedKeyword(value);
      setIsOtherSelected(false);
      setOtherKeyword(""); // Reset other keyword if switching back
    }
  };

  const handleOtherInputChange = (e) => {
    setOtherKeyword(e.target.value);
  };

  // Pagination calculations
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData
    ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = filteredData
    ? Math.ceil(filteredData.length / itemsPerPage)
    : 0;

  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };

  return (
    <div>
      {showLoaderAdmin && <Loader />}
      {!formVisible && (
        <>
          <div className="headSeo">
            <button
              type="button"
              onClick={handleToggleForm}
              className="btn btn-secondary"
            >
              {BlogWebsite_text.Add_Blog}
            </button>
          </div>
          <div className="seoTable_container">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ color: "#09c70794", fontWeight: "600" }}>
                    {BlogWebsite_text.Create_Date}
                  </th>
                  <th style={{ color: "#09c70794", fontWeight: "600" }}>
                    {BlogWebsite_text.Image}
                  </th>
                  <th style={{ color: "#09c70794", fontWeight: "600" }}>
                    {BlogWebsite_text.Title}
                  </th>
                  <th style={{ color: "#09c70794", fontWeight: "600" }}>
                    {BlogWebsite_text.Description}
                  </th>
                  <th style={{ color: "#09c70794", fontWeight: "600" }}>
                    {BlogWebsite_text.Keywords}
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems &&
                  currentItems.length > 0 &&
                  currentItems.map((option, index) => (
                    <React.Fragment key={index}>
                      <tr className="seoTable_row">
                        <td className="col-xs serial-span">
                          <div>
                            <span className="indexNumber">
                              {indexOfFirstItem + index + 1}
                            </span>
                            <p>{mondayDayYearFormat(option.entry_date)}</p>
                          </div>
                        </td>
                        <td>
                          <img
                            src={option.image_url}
                            onError={(e) => (e.target.src = teamimage)}
                            alt="Rapid Car Leasing"
                          />
                        </td>
                        <td className="col-md">
                          <div>{option.title_name}</div>
                        </td>
                        <td>
                          <div>{option.tag_line}</div>
                        </td>
                        <td>{option.author}</td>
                      </tr>
                      <tr className="actionRow">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <div className="img-icons mb-4">
                            <img
                              onClick={() => handleShow(option)}
                              className="del-icon"
                              src={delicon}
                              alt=""
                            />
                            <img
                              onClick={() => handleEdit(option)}
                              className=""
                              src={update}
                              alt=""
                            />
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>

            {/* Pagination Controls */}
            <div className="cust_hist_card_footer">
              <div className="cust_hist_pagination_info">
                {filteredData && filteredData.length > 0 ? (
                  <>
                    Showing{" "}
                    <span className="cust_hist_pagination_bold">
                      {indexOfFirstItem + 1}
                    </span>{" "}
                    to{" "}
                    <span className="cust_hist_pagination_bold">
                      {Math.min(indexOfLastItem, filteredData.length)}
                    </span>{" "}
                    of{" "}
                    <span className="cust_hist_pagination_bold">
                      {filteredData.length}
                    </span>{" "}
                    blogs
                  </>
                ) : (
                  <>
                    Showing <span className="cust_hist_pagination_bold">0</span>{" "}
                    blogs
                  </>
                )}
              </div>
              <div className="cust_hist_pagination">
                <nav aria-label="Pagination">
                  <ul className="cust_hist_pagination_list">
                    {renderPaginationButtons()}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </>
      )}

      {formVisible && (
        <form id="addNewStaff">
          <div className="event-box blog-data mb-3">
            <div className="d-flex justify-content-between">
              <button
                style={{ fontWeight: "500" }}
                type="button"
                className="btn custom-btn"
              >
                {BlogWebsite_text.Add_Blog}
              </button>
              <Button
                onClick={() => {
                  setFormVisible(false);
                  empty_form_new("addNewStaff");
                  resetForm();
                }}
                className="Back_bttn_page"
              >
                <ArrowLeft size={17} style={{ marginBottom: "2px" }} /> Back
              </Button>
            </div>

            <div className="form-group mt-4">
              <div className="row m-0">
                <div className="col-md-6" title="Image size: 400x250 px">
                  <input
                    type="file"
                    name="doctor_image_blog1"
                    id="doctor_image_blog1"
                    onChange={handleFileChange3}
                    className="form-control "
                    style={{ display: "none", cursor: "pointer" }}
                  />
                  <label
                    htmlFor="doctor_image_blog1"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    className="form-control"
                  >
                    <span>
                      {selectedFileBlog2
                        ? selectedFileBlog2.name
                        : "Choose Blog Card Image"}
                    </span>
                    {/* {selectedFileBlog2 && (
                      <div
                        className="recentReservBtns"
                        style={{ position: "static", zIndex: 10 }}
                      >
                        <button
                          style={{
                            width: "fit-content",
                            backgroundColor: "#d9d9d9",
                          }}
                          onClick={(e) => {
                            e.preventDefault(); // Prevent label default
                            e.stopPropagation(); // Stop bubbling to label
                            setSelectedFileBlog2(null);
                          }}
                        >
                          <p style={{ color: "#313131" }}>Remove</p>
                          <Trash2 color="red" size={14} />
                        </button>
                      </div>
                    )} */}
                  </label>
                  <span
                    style={{ fontSize: "12px", color: "red", margin: "0px" }}
                  >
                    Upload an Image of Size 400x250 px
                  </span>
                  <span className="condition_error"></span>
                </div>
                <div className="col-md-6" title="Image size: 400x250 px">
                  <input
                    type="file"
                    name="doctor_image_blog"
                    id="doctor_image_blog"
                    onChange={handleFileChange2}
                    className="form-control "
                    style={{ display: "none", cursor: "pointer" }}
                  />
                  <label
                    htmlFor="doctor_image_blog"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    className="form-control"
                  >
                    <span>
                      {selectedFileBlog
                        ? selectedFileBlog.name
                        : "Choose Main Blog Image"}
                    </span>
                    {/* {selectedFileBlog && (
                      <div
                        className="recentReservBtns"
                        style={{ position: "static", zIndex: 10 }}
                      >
                        <button
                          style={{
                            width: "fit-content",
                            backgroundColor: "#d9d9d9",
                          }}
                          onClick={(e) => {
                            e.preventDefault(); // Prevent label default
                            e.stopPropagation(); // Stop bubbling to label
                            setSelectedFileBlog2(null);
                          }}
                        >
                          <p style={{ color: "#313131" }}>Remove</p>
                          <Trash2 color="red" size={14} />
                        </button>
                      </div>
                    )} */}
                  </label>
                  <span
                    style={{ fontSize: "12px", color: "red", margin: "0px" }}
                  >
                    Upload an Image of Size 1400x430 px
                  </span>
                  <span className="condition_error"></span>
                </div>

                <div className="col-md-6 mt-2">
                  <input
                    type="text"
                    name="old_image_author"
                    id="old_image_author"
                    defaultValue={editStaffDataDetails.author_image || ""}
                    onInput={handleURLChange}
                    className="form-control trio_mandatory"
                    placeholder="Enter Author Image URL*"
                  />
                  <span className="condition_error"></span>
                </div>
                <div className="col-md-3 mt-2">
                  <input
                    type="text"
                    id="read_minit"
                    defaultValue={editStaffDataDetails.read_minit || ""}
                    name="read_minit"
                    onInput={handleNumbersChange}
                    className="form-control trio_mandatory"
                    placeholder="read time*"
                  />
                  <span className="condition_error"></span>
                </div>
                <div className="col-md-3 mt-2">
                  <input
                    type="text"
                    id="author_data"
                    defaultValue={editStaffDataDetails.author || ""}
                    name="author_data"
                    // onInput={handleIaphabetnumberChange}
                    className="form-control trio_mandatory"
                    placeholder="Author*"
                  />
                  <span className="condition_error"></span>
                </div>
                <div className="col-md-6 mt-2">
                  <input
                    type="text"
                    name="page_url_data"
                    defaultValue={editStaffDataDetails.page_url_data || ""}
                    id="page_url_data"
                    // onInput={handleAphabetsChange}
                    className="form-control"
                    placeholder="Enter Page Url*"
                  />
                  <span className="condition_error"></span>
                </div>
                {/* {editStaffDataDetails && editStaffDataDetails.keyword_id && ( */}
                <div className="col-md-6 mt-2">
                  <div className="inpContainer curser_Pointer">
                    <div className="person__business_center_image image_icon_position1">
                      <div className="dropDownn">
                        <img src={DropDwn} alt="img"></img>
                      </div>

                      <select
                        id="keyword"
                        name="keyword"
                        className="trio_mandatory form-control input_field_custom1"
                        defaultValue={selectedKeyword}
                        onChange={handleKeywordChange}
                      >
                        <option value="" disabled>
                          Select Keyword
                        </option>
                        {blogDataKeyWord.map((option, index) => (
                          <option
                            key={index}
                            value={`${option.primary_id}~@~${option.keyword}`}
                            selected={
                              parseInt(editStaffDataDetails.keyword_id) ===
                              parseInt(option.primary_id)
                            }
                          >
                            {option.keyword}
                          </option>
                        ))}
                        <option value="other">Other</option>
                      </select>

                      {isOtherSelected && (
                        <div className="mt-3">
                          <input
                            type="text"
                            className="form-control input_field_custom1"
                            placeholder="Enter your keyword"
                            value={otherKeyword}
                            onChange={handleOtherInputChange}
                          />
                        </div>
                      )}
                      <span className="condition_error"></span>
                    </div>
                  </div>
                </div>
                {/* )} */}
                <div className="col-md-12">
                  <input
                    type="text"
                    name="title_data"
                    defaultValue={editStaffDataDetails.title_name || ""}
                    id="title_data"
                    // onInput={handleAphabetsChange}
                    className="form-control trio_mandatory"
                    placeholder="Enter Title*"
                  />
                  <span className="condition_error"></span>
                </div>

                <div className="col-md-12">
                  <textarea
                    className="textareBlogs form-control trio_mandatory"
                    name="tagline_data"
                    id="tagline_data"
                    style={{ border: "1px solid var(--border-color)" }}
                    defaultValue={editStaffDataDetails.tag_line || ""}
                    // onInput={handleIaphabetnumberChange}
                    placeholder="Enter Introduction*"
                  ></textarea>
                  <span className="condition_error"></span>
                </div>

                <div className={`col-md-12`}>
                  <div className="inpContainer mt-2">
                    <label className="no_prsnl_id">
                      {BlogWebsite_text.Description}
                      <span>*</span>
                    </label>
                    <div>
                      <CKEditor
                        editor={ClassicEditor}
                        data={editorData}
                        config={{
                          extraPlugins: [uploadPlugin],
                          toolbar: [
                            "heading",
                            "|",
                            "bold",
                            "italic",
                            "link",
                            "bulletedList",
                            "numberedList",
                            "|",
                            "outdent",
                            "indent",
                            "|",
                            "imageUpload",
                            "blockQuote",
                            "insertTable",
                            "|",
                            "undo",
                            "redo",
                          ],
                          heading: {
                            options: [
                              {
                                model: "paragraph",
                                title: "Paragraph",
                                class: "ck-heading_paragraph",
                              },
                              {
                                model: "heading1",
                                view: "h1",
                                title: "Heading 1",
                                class: "ck-heading_heading1",
                              },
                              {
                                model: "heading2",
                                view: "h2",
                                title: "Heading 2",
                                class: "ck-heading_heading2",
                              },
                              {
                                model: "heading3",
                                view: "h3",
                                title: "Heading 3",
                                class: "ck-heading_heading3",
                              },
                              {
                                model: "heading4",
                                view: "h4",
                                title: "Heading 4",
                                class: "ck-heading_heading4",
                              },
                              {
                                model: "heading5",
                                view: "h5",
                                title: "Heading 5",
                                class: "ck-heading_heading5",
                              },
                              {
                                model: "heading6",
                                view: "h6",
                                title: "Heading 6",
                                class: "ck-heading_heading6",
                              },
                            ],
                          },
                          image: {
                            toolbar: [
                              "imageStyle:inline",
                              "imageStyle:block",
                              "imageStyle:side",
                              "|",
                              "imageTextAlternative",
                            ],
                          },
                        }}
                        onChange={handleEditorChange}
                        onReady={(editor) => {
                          //console.log("Editor is ready!", editor);
                        }}
                      />
                    </div>
                    <span className="condition_error">{error_show}</span>
                  </div>
                </div>

                <div className="col-md-12" title="Image size: 400x250 px">
                  <input
                    type="file"
                    name="doctor_image_blog2"
                    id="doctor_image_blog2"
                    onChange={handleFileChange4}
                    className="form-control "
                    style={{ display: "none", cursor: "pointer" }}
                  />
                  <label
                    htmlFor="doctor_image_blog2"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    className="form-control"
                  >
                    <span>
                      {selectedFileBlog4
                        ? selectedFileBlog4.name
                        : "Choose Main Blog Image 2"}
                    </span>
                    {/* {selectedFileBlog4 && (
                      <div
                        className="recentReservBtns"
                        style={{ position: "static", zIndex: 10 }}
                      >
                        <button
                          style={{
                            width: "fit-content",
                            backgroundColor: "#d9d9d9",
                          }}
                          onClick={(e) => {
                            e.preventDefault(); // Prevent label default
                            e.stopPropagation(); // Stop bubbling to label
                            setSelectedFileBlog2(null);
                          }}
                        >
                          <p style={{ color: "#313131" }}>Remove</p>
                          <Trash2 color="red" size={14} />
                        </button>
                      </div>
                    )} */}
                  </label>
                  <span
                    style={{ fontSize: "12px", color: "red", margin: "0px" }}
                  >
                    Upload an Image of Size 400x250 px
                  </span>
                  <span className="condition_error"></span>
                </div>

                <div className={`col-md-12`}>
                  <div className="inpContainer mt-2">
                    <label className="no_prsnl_id">
                      {BlogWebsite_text.Description} 2<span>*</span>
                    </label>
                    <div>
                      <CKEditor
                        editor={ClassicEditor}
                        data={editorData2}
                        config={{
                          extraPlugins: [uploadPlugin],
                          toolbar: [
                            "heading",
                            "|",
                            "bold",
                            "italic",
                            "link",
                            "bulletedList",
                            "numberedList",
                            "|",
                            "outdent",
                            "indent",
                            "|",
                            "imageUpload",
                            "blockQuote",
                            "insertTable",
                            "|",
                            "undo",
                            "redo",
                          ],
                          heading: {
                            options: [
                              {
                                model: "paragraph",
                                title: "Paragraph",
                                class: "ck-heading_paragraph",
                              },
                              {
                                model: "heading1",
                                view: "h1",
                                title: "Heading 1",
                                class: "ck-heading_heading1",
                              },
                              {
                                model: "heading2",
                                view: "h2",
                                title: "Heading 2",
                                class: "ck-heading_heading2",
                              },
                              {
                                model: "heading3",
                                view: "h3",
                                title: "Heading 3",
                                class: "ck-heading_heading3",
                              },
                              {
                                model: "heading4",
                                view: "h4",
                                title: "Heading 4",
                                class: "ck-heading_heading4",
                              },
                              {
                                model: "heading5",
                                view: "h5",
                                title: "Heading 5",
                                class: "ck-heading_heading5",
                              },
                              {
                                model: "heading6",
                                view: "h6",
                                title: "Heading 6",
                                class: "ck-heading_heading6",
                              },
                            ],
                          },
                          image: {
                            toolbar: [
                              "imageStyle:inline",
                              "imageStyle:block",
                              "imageStyle:side",
                              "|",
                              "imageTextAlternative",
                            ],
                          },
                        }}
                        onChange={handleEditorChange2}
                        onReady={(editor) => {
                          //console.log("Editor is ready!", editor);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12" title="Image size: 400x250 px">
                  <input
                    type="file"
                    name="doctor_image_blog3"
                    id="doctor_image_blog3"
                    onChange={handleFileChange5}
                    className="form-control "
                    style={{ display: "none", cursor: "pointer" }}
                  />
                  <label
                    htmlFor="doctor_image_blog3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    className="form-control"
                  >
                    <span>
                      {selectedFileBlog5
                        ? selectedFileBlog5.name
                        : "Choose Main Blog Image 3"}
                    </span>
                    {/* {selectedFileBlog5 && (
                      <div
                        className="recentReservBtns"
                        style={{ position: "static", zIndex: 10 }}
                      >
                        <button
                          style={{
                            width: "fit-content",
                            backgroundColor: "#d9d9d9",
                          }}
                          onClick={(e) => {
                            e.preventDefault(); // Prevent label default
                            e.stopPropagation(); // Stop bubbling to label
                            setSelectedFileBlog2(null);
                          }}
                        >
                          <p style={{ color: "#313131" }}>Remove</p>
                          <Trash2 color="red" size={14} />
                        </button>
                      </div>
                    )} */}
                  </label>
                  <span
                    style={{ fontSize: "12px", color: "red", margin: "0px" }}
                  >
                    Upload an Image of Size 400x250 px
                  </span>
                  <span className="condition_error"></span>
                </div>

                <div className={`col-md-12`}>
                  <div className="inpContainer mt-2">
                    <label className="no_prsnl_id">
                      {BlogWebsite_text.Description} 3<span>*</span>
                    </label>
                    <div>
                      <CKEditor
                        editor={ClassicEditor}
                        data={editorData3}
                        config={{
                          extraPlugins: [uploadPlugin],
                          toolbar: [
                            "heading",
                            "|",
                            "bold",
                            "italic",
                            "link",
                            "bulletedList",
                            "numberedList",
                            "|",
                            "outdent",
                            "indent",
                            "|",
                            "imageUpload",
                            "blockQuote",
                            "insertTable",
                            "|",
                            "undo",
                            "redo",
                          ],
                          heading: {
                            options: [
                              {
                                model: "paragraph",
                                title: "Paragraph",
                                class: "ck-heading_paragraph",
                              },
                              {
                                model: "heading1",
                                view: "h1",
                                title: "Heading 1",
                                class: "ck-heading_heading1",
                              },
                              {
                                model: "heading2",
                                view: "h2",
                                title: "Heading 2",
                                class: "ck-heading_heading2",
                              },
                              {
                                model: "heading3",
                                view: "h3",
                                title: "Heading 3",
                                class: "ck-heading_heading3",
                              },
                              {
                                model: "heading4",
                                view: "h4",
                                title: "Heading 4",
                                class: "ck-heading_heading4",
                              },
                              {
                                model: "heading5",
                                view: "h5",
                                title: "Heading 5",
                                class: "ck-heading_heading5",
                              },
                              {
                                model: "heading6",
                                view: "h6",
                                title: "Heading 6",
                                class: "ck-heading_heading6",
                              },
                            ],
                          },
                          image: {
                            toolbar: [
                              "imageStyle:inline",
                              "imageStyle:block",
                              "imageStyle:side",
                              "|",
                              "imageTextAlternative",
                            ],
                          },
                        }}
                        onChange={handleEditorChange3}
                        onReady={(editor) => {
                          //console.log("Editor is ready!", editor);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <Multiselect
                    options={ALLblogFaq}
                    selectedValues={selectedValues}
                    onSelect={onSelect}
                    onRemove={onRemove}
                    displayValue="question_name"
                  />
                </div>
                <div className="col-md-12">
                  <div className="addBlogBtnDiv">
                    <button
                      type="button"
                      onClick={() =>
                        handleSaveChangesdynamic(
                          "addNewStaff",
                          save_update_blog
                        )
                      }
                      className="btn btn-secondary mt-1 save-cap-btn"
                    >
                      {BlogWebsite_text.save_txt}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}

      <Modal
        show={modalShow}
        className="confirmModal"
        centered
        backdrop="static"
        keyboard={false}
        onHide={handleClose}
      >
        <Modal.Header className="confirmModalHeader" closeButton></Modal.Header>
        <Modal.Body className="confirmBody">
          <p className="modalText">Do You Want to Delete This Data?</p>
        </Modal.Body>
        <Modal.Footer className="confirmModalFooter">
          <Button
            className={`closeConfirmAeBtn closeConfirmBtn`}
            onClick={handleClose}
          >
            {BlogWebsite_text.no_txt}
          </Button>
          <Button
            className={`confirmAeBtn Confirm_Deactive`}
            onClick={handleDeactivate}
          >
            <label
              style={{ cursor: "pointer" }}
              htmlFor={`dynamic_id${SelectedData.primary_id}`}
            >
              {BlogWebsite_text.Yes_txt}
            </label>
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default BlogWebsite;
